export const DEFAULT_UPDATES_PER_PAGE = 50

export const getUpdatesLink = ({ id, type, key }: { id: string; type: string; key: string }) => {
  const urlKeyMap = {
    addedAssetsCount: `/plus/profile/${id}/products`,
  }
  return urlKeyMap[key as keyof typeof urlKeyMap] ?? `/plus/profile/${id}/${type}`
}
